import { ANALYSIS_PROMPTS, type AnalysisPromptOption } from './buildTranscriptExport';

/**
 * Промт по умолчанию для обязательного маршрута анализа в ChatGPT.
 * Соответствует типу встречи; для неизвестных/пустых типов — общие итоги.
 */
export function resolveDefaultAnalysisPrompt(
  meetingType: string | null | undefined,
): AnalysisPromptOption {
  const normalized = meetingType?.trim().toUpperCase() ?? '';
  const promptId =
    normalized === 'PRE_SALE'
      ? 'presale'
      : normalized === 'CLIENT_WORK'
        ? 'client_work'
        : normalized === 'INTERNAL'
          ? 'internal'
          : 'summary';
  const found = ANALYSIS_PROMPTS.find((prompt) => prompt.id === promptId);
  return found ?? ANALYSIS_PROMPTS[0]!;
}
